<!-- кнопка операций в колонке операций в компоненте List -->
<template>
	<!-- для мобил -->
	<div v-if="Object.keys(data).length > 0 && ((isCrudOpers && canShowCrudButton) || isOtherOpers) && $store.state.windowWidth <= 767" class="w5-opers-button-for-mobile">
		<!-- сначала идут CRUD-операции без удаления, если они конечно заданы -->
		<div v-if="'create' in data" @click.stop="clickOper('create')" class="w5-opers-button-curd-btn">
			<font-awesome-icon icon="plus" />
		</div>
		<div v-if="'update' in data" @click.stop="clickOper('update')" class="w5-opers-button-curd-btn">
			<font-awesome-icon icon="pencil-alt" class="color-green" />
		</div>
		<div v-if="'clone' in data" @click.stop="clickOper('clone')" class="w5-opers-button-curd-btn">
			<font-awesome-icon icon="clone" />
		</div>

		<!-- остальные операции -->			
		<div v-for="(oper, key) in data" @click.stop="clickOper(key)" class="w5-opers-button-curd-btn" :key="'other-opers-' + key">
			<template v-if="isOperButtonVisible(key)">
				<font-awesome-layers class="w5-dropdown-menu-item w5-opers-button-other-btn">
					<font-awesome-icon v-for="(cls, idx) in classOper(key)" :icon="cls" :class="classOperClasses(key, idx)" :key="'icon-' + cls" />
				</font-awesome-layers>
			</template>
		</div>

		<!-- кнопка удаления последняя -->
		<div v-if="'delete' in data" @click.stop="clickOper('delete')" class="w5-opers-button-curd-btn">
			<font-awesome-icon icon="trash-alt" class="color-red" />
		</div>
	</div>

	<!-- для десктопов -->
	<div v-else-if="Object.keys(data).length > 0 && ((isCrudOpers && canShowCrudButton) || isOtherOpers) && $store.state.windowWidth > 767"
		:class="{ 'w5-opers-button-opened': show }"
		class="btn-group w5-opers-button"
		@click.stop="toggleMenu"
		:data-index="index">
		<!-- сама кнопка -->
		<span class="dropdown-toggle">
			<font-awesome-icon icon="bars" /> <span class="caret"></span>
		</span>
		<!-- пункты меню -->
		<ul v-show="show" class="dropdown-menu" role="menu" @click.stop :style="cssUl">

			<!-- сначала идут CRUD-операции без удаления, если они конечно заданы -->
			<template v-if="isCrudOpers && canShowCrudButton">

				<li v-if="'create' in data" @click.stop="clickOper('create')">
					<span class="w5-dropdown-menu-item w5-opers-button-other-btn">
						<font-awesome-icon icon="plus" />
						{{ data['create']['title'] ? data['create']['title'] : this.crud + '/create_title' | ftc }}
					</span>
				</li>
				<li v-if="'update' in data" @click.stop="clickOper('update')">
					<span class="w5-dropdown-menu-item w5-opers-button-other-btn">
						<font-awesome-icon icon="pencil-alt" class="color-green" />
						{{ data['update']['title'] ? data['update']['title'] : 'main/redact' | ftc }}
					</span>
				</li>
				<li v-if="'clone' in data" @click.stop="clickOper('clone')">
					<span class="w5-dropdown-menu-item w5-opers-button-other-btn">
						<font-awesome-icon icon="clone" />
						{{ data['clone']['title'] ? data['clone']['title'] : 'main/clone' | ftc }}
					</span>
				</li>

			</template>

			<!-- разделитель -->
			<li v-if="('create' in data || 'update' in data || 'clone' in data) && isOtherOpers" class="divider"></li>

			<!-- остальные операции -->			
			<li v-for="(oper, key) in data" @click.stop="clickOper(key)" :key="'other-opers-' + key">
				<template v-if="isOperButtonVisible(key)">
					<font-awesome-layers class="w5-dropdown-menu-item w5-opers-button-other-btn">
						<font-awesome-icon v-for="(cls, idx) in classOper(key)" :icon="cls" :class="classOperClasses(key, idx)" :key="'icon-' + cls" />
						<template v-if="key === 'ipptrpool'">
							{{ oper['title'] ? oper['title'] : '' | ftc }}
						</template>
						<template v-else>
							{{ oper['title'] ? oper['title'] : '' | ftc | capitalize }}
						</template>
					</font-awesome-layers>
				</template>
			</li>

			<!-- кнопка удаления последняя -->
			<template v-if="isCrudOpers && canShowCrudButton && 'delete' in data">
				<!-- разделитель -->
				<li v-if="('create' in data || 'update' in data || 'clone' in data) || isOtherOpers" class="divider"></li>
				<li @click.stop="clickOper('delete')">
					<span class="w5-dropdown-menu-item w5-opers-button-other-btn">
						<font-awesome-icon icon="trash-alt" class="color-red" />
						{{ data['delete']['title'] ? data['delete']['title'] : 'main/delete' | ftc }}
					</span>
				</li>
			</template>
			
		</ul>
	</div>
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
import $ from 'jquery'
import Helper from '@/helper/helper'
import { EventBus } from '@/bus.js'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование
	//=========================================================================
	name: 'listDropDownOpersButtonComponent',
	//=========================================================================
	// данные - пункты меню
	//=========================================================================
	props: ['dataConfig', 'row', 'index', 'crud'],
	//=========================================================================
	// локальные переменные
	//=========================================================================
	data() {
		return {
			// показывать/скрывать все меню
			show: false,
			// данные
			data: {},
			// строка - заводим ее, так как она может меняться родителем
			Row: null,
			// стиль для блока с меню
			cssUl: false
		}
	},
	//=========================================================================
	// кмопонент создан
	//=========================================================================
	created() {
		this.Row = this.row
		this.initButtons()
	},
	//=========================================================================
	//  вычисляемые неизменяемые переменные
	//=========================================================================
	computed: {
		isCrudOpers() {
			return 'create' in this.data || 'update' in this.data || 'delete' in this.data || 'clone' in this.data
		},
		isOtherOpers() {
			for (let i in this.data)
			{
				if (i !== 'create' && i !== 'update' && i !== 'delete' && i !== 'clone')
				{
					if (this.isOperButtonVisible(i)) return true
				}
			}

			return false
		},
		statusTextField() {
			if (!this.Row) return false
			// ищем в строке колонку со статусом процесса
			let _statusField = false
			// ищем в первой строке
			for (let _s in this.Row)
			{
				// если это поле статуса
				if (/_status_text$/ig.test(_s))
				{
					_statusField = _s
					break
				}
			}

			return _statusField
		},
		canShowCrudButton() {
			// если нет строки - нельзя
			if (!this.Row) return false

			// смотрим статус процесса
			let _text = this.statusTextField
			// если его нет - можно
			// кроме пользователей
			if (!_text || this.crud === 'user') return true
			// если текстовый статус есть и он не пустой
			if (this.Row[_text])
			{
				// частный случай
				if (this.crud === 'vds')
				{
					// если при этом сам статус не активен - нельзя
					if (this.Row['service_status'] !== 'active')
						return false
				}
				// нельзя
				else return false
			}

			// по умолчанию можно
			return true
		}
	},
	//=========================================================================
	// после того как компонент смонтирован
	//=========================================================================
	mounted() {
		$(document).on('keydown.dropdownmenu.' + this.index, this.KeyDownHandler)
		$(document).on('toggleDropDownOperMenu.' + this.index, this.handleToggle)
		$(document).on('click.dropdownmenu.' + this.index, this.ClickOnDocument)
		EventBus.$on('w5-update-row', this.updateRowHandler)
	},
	//=========================================================================
	// перед уничтожением компонента
	//=========================================================================
	beforeDestroy() {
		$(document).off('keydown.dropdownmenu.' + this.index, this.KeyDownHandler)
		$(document).off('toggleDropDownOperMenu.' + this.index, this.handleToggle)
		$(document).off('click.dropdownmenu.' + this.index, this.ClickOnDocument)
		EventBus.$off('w5-update-row', this.updateRowHandler)
	},
	//=========================================================================
	// локальные методы компонента
	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		// показывает/скрывает меню
		//---------------------------------------------------------------------
		toggleMenu(e) {
			// информируем другие блоки - мы кликнули по кнопке
			$(document).trigger('toggleDropDownOperMenu', [this.index])
			// меняем видимость на противоположную
			this.show = !this.show
			// рассчитаем - куда открывать
			this.UpOrDown()
		},
		//---------------------------------------------------------------------
		// обработчик события - закрывают или открывают какое то такое же меню
		//---------------------------------------------------------------------
		handleToggle(e, idx) {
			// если не наше - то наше нужно просто закрыть
			if (idx !== this.index) this.hideMenu()
		},
		//---------------------------------------------------------------------
		// скрывает меню
		//---------------------------------------------------------------------
		hideMenu() {
			this.show = false
		},
		//---------------------------------------------------------------------
		// кликнули по пункту меню
		//---------------------------------------------------------------------
		clickOper(action) {
			this.hideMenu()

			let _action = this.data[action]
			if (this.crud === 'user' && this.$store.state.user_type !== 'admin')
			{
				if (action === 'update' && this.Row['user_id'] === this.$store.state.user_id)
					_action = { 'action': 'url:/options' }
			}

			if (action === 'accountReport')
			{
				// создаем здесь вкладку - при непосредственном клике пользователя
				let _w = window.open()
				// и передаем дальше в обработчик
				_action.w = _w
			}

			this.$emit('action', {
				'action': action,
				'data': _action,
				'row': this.Row
			})
		},
		//---------------------------------------------------------------------
		// функция возвращает массив классов для иконок пункта меню
		//---------------------------------------------------------------------
		classOper(action) {
			if (action === 'log' || action === 'logOver') return ['list']
			else if (action === 'filter') return ['filter']
			else if (action === 'note') return ['thumbtack']
			else if (action === 'createNote') return ['plus', 'thumbtack']
			else if (action === 'request' || action === 'serviceRequest') return ['exclamation-circle']
			else if (action === 'operation' || action === 'paymentLink') return (this.AppName === 'vdsina.com' ? ['dollar-sign'] : ['ruble-sign'])
			else if (action === 'user') return ['users']
			else if (action === 'partnerAction') return ['list-ul']
			else if (action === 'partner') return ['handshake']
			else if (action === 'server') return ['server']
			else if (action === 'plan') return ['search-dollar']
			else if (action === 'vdsReboot' || action === 'domainReboot') return ['power-off']
			else if (action === 'vdsPlan') return ['tasks']
			else if (action === 'vdsReinstall') return ['history']
			else if (action === 'vdsChangePassword') return ['random']
			else if (action === 'prolong') return ['play-circle']
			else if (action === 'ticketMerge') return ['compress-alt']
			else if (action === 'account') return ['user-circle']
			else if (action === 'bonusActivate') return ['trophy']
			else if (action === 'pdfLink' || action === 'xmlLink') return ['file-download']
			else if (action === 'operLink') return ['file-invoice']
			else if (action === 'mailDocument') return ['envelope']
			else if (action === 'restoreBackup' || action === 'connectOuterDisk' || action === 'restoreBackupOuterDisk') return ['hdd']
			else if (action === 'scheduleOuterDisk' || action === 'scheduleOuterDiskUpdate') return ['clock']
			else if (action === 'ejectOuterDisk' || action === 'ejectISOOper') return ['eject']
			else if (action === 'renameBackup') return ['pencil-alt']
			else if (action === 'createFromBackup' || action === 'createFromBackupOuterDisk' || action === 'createDevice' || action === 'backupOuterDisk') return ['plus']
			else if (action === 'clientTicket') return ['envelope']
			else if (action === 'accountReport') return ['clipboard']
			else if (action === 'rackGraphic') return ['grip-vertical']
			else if (action === 'removeFilter') return ['ban']
			else if (action === 'copyToDc') return ['hdd', 'share']
			else if (action === 'downloadBackup') return ['cloud-download-alt']
			else if (action === 'deviceLinks') return ['link']
			else if (action === 'ipptrpool') return ['network-wired']
			else if (action === 'ipHistory') return ['history']
			else if (action === 'ipReserve') return ['hourglass-half']
			else if (action === 'vdsClone') return ['server', 'clone']
			else if (action === 'connectISOOper') return ['compact-disc']
			else if (action === 'cloneOuterDisk') return ['clone']

			// класс по умолчанию
			return ['sun']
		},
		//---------------------------------------------------------------------
		//
		//---------------------------------------------------------------------
		classOperClasses(key, idx = 0) {
			if (key === 'createNote')
			{
				return !idx ? 'w5-oper-menu-icon-plus' : 'w5-oper-menu-icon-note'
			}
			else if (key === 'copyToDc')
			{
				return !idx ? 'w5-oper-menu-icon-hdd' : 'w5-oper-menu-icon-share'
			}
			else if (key === 'vdsClone')
			{
				return !idx ? 'w5-oper-menu-icon-vds-clone-server' : 'w5-oper-menu-icon-vds-clone-clone'
			}

			return null
		},
		//---------------------------------------------------------------------
		// обработчик нажатий клавиш
		//---------------------------------------------------------------------
		KeyDownHandler(e) {
			if (this.show && e.keyCode === 27) this.hideMenu()
		},
		//---------------------------------------------------------------------
		// обработчик клика по документу
		//---------------------------------------------------------------------
		ClickOnDocument(e) {
			if (this.show) this.hideMenu()
		},
		//---------------------------------------------------------------------
		// можно показывать кнопку или нет
		//---------------------------------------------------------------------
		isOperButtonVisible(key) {
			if (key !== 'create' && key !== 'update' && key !== 'delete' && key !== 'clone')
			{
				// если это операции для VDS
				if (key === 'vdsReboot' || key === 'vdsPlan' || key === 'vdsReinstall' || key === 'vdsChangePassword' || key === 'vdsClone')
				{
					// для клонирования вдс свои условия
					if (key === 'vdsClone')
					{
						// если архивный тариф
						if (this.Row['service_data'] && this.Row['service_data']['plan'])
						{
							if (String(this.Row['service_data']['plan']['status']) !== 'active') return false
							if (String(this.Row['service_data']['plan']['name']).toLowerCase().indexOf('архивный') > -1) return false
						}
					}

					// нужно проверить статус
					if (this.Row['service_status'] !== 'active' || this.Row['service_status_text']) return false
					else return true
				}
				// если это пролонгация услуги
				else if (key === 'prolong')
				{
					if (this.Row['can_prolong'] !== true || this.Row['service_status_text']) return false
					else return true
				}
				// если это объединение тикетов
				else if (key === 'ticketMerge')
				{
					if (this.Row['can_merge'] !== true) return false
					else return true
				}
				// если это получение ссылки на оплату
				else if (key === 'paymentLink')
				{
					if (!this.Row['external_hash']) return false
					else return true
				}
				// если это ссылка на PDF документ
				else if (key === 'pdfLink')
				{
					if (!this.Row['pdf']) return false
					else return true
				}
				// если это ссылка на XML документ
				else if (key === 'xmlLink')
				{
					if (!this.Row['xml']) return false
					else return true
				}
				// если это ссылка на просмотр операции по документу
				else if (key === 'operLink')
				{
					if (!this.Row['operation_id']) return false
					else return true
				}
				// если это отправка документа на мыло
				else if (key === 'mailDocument')
				{
					if (this.Row['can_mail'] !== true) return false
					else return true
				}
				// если это активация бонуса сотрудником
				else if (key === 'bonusActivate')
				{
					if (this.crud === 'bonus')
					{
						if (this.Row['bonus_status'] !== 'active') return false
						else return true
					}
					else return true
				}
				// если это операции для доменов
				else if (key === 'domainReboot')
				{
					// нужно проверить статус
					if (this.Row['service_status'] !== 'active' || this.Row['service_status_text'] || this.Row['can_reboot'] !== true) return false
					else return true
				}
				// если это восстановление из бэкапа
				else if (key === 'restoreBackup' || key === 'renameBackup')
				{
					// нужно проверить статус
					if (this.Row['service_status'] !== 'active' || this.Row['service_status_text']) return false
					else return true
				}
				// если это ссылка на создание сервера из заданного бэкапа,
				// или создание внешнего диска из заданного бэкапа
				else if (key === 'createFromBackup' || key === 'createFromBackupOuterDisk')
				{
					// нужно проверить статус
					if (this.Row['service_status'] !== 'active' || this.Row['service_status_text']) return false
					else return true
				}
				// если это копирование бэкапа
				else if (key === 'copyToDc')
				{
					if (this.Row['service_status'] !== 'active' || this.Row['service_status_text']) return false
					return this.isAccess('service/copy')
				}
				// если это отчет по аккаунту
				else if (key === 'accountReport')
				{
					return this.isAccess('account/report')
				}
				// если это генерация ссылки для скачивания бэкапа
				else if (key === 'downloadBackup')
				{
					if (this.Row['service_status'] !== 'active' || this.Row['service_status_text'] || this.Row['can_download'] !== true) return false
					return this.isAccess('service/update')
				}
				else if (key === 'connectOuterDisk')
				{
					// нужно проверить статус
					if (this.Row['service_status'] !== 'active' || this.Row['service_status_text']) return false
					else {
						if (this.Row['service_data'] && this.Row['service_data']['extdisk'] && this.Row['service_data']['extdisk']['attached'] === true) return false
						return true
					}
				}
				else if (key === 'ejectOuterDisk')
				{
					// нужно проверить статус
					if (this.Row['service_status'] !== 'active' || this.Row['service_status_text']) return false
					else {
						if (this.Row['service_data'] && this.Row['service_data']['extdisk'] && this.Row['service_data']['extdisk']['attached'] === true) return true
						return false
					}
				}
				else if (key === 'cloneOuterDisk')
				{
					// нужно проверить статус
					if (this.Row['service_status'] !== 'active' || this.Row['service_status_text']) return false
					return this.isAccess('service/clone')
				}
				else if (key === 'backupOuterDisk')
				{
					// нужно проверить статус
					if (this.Row['service_status'] !== 'active' || this.Row['service_status_text']) return false
					return this.isAccess('service/create')
				}
				else if (key === 'restoreBackupOuterDisk')
				{
					// нужно проверить статус
					if (this.Row['service_status'] !== 'active' || this.Row['service_status_text']) return false
					return this.isAccess('service/update')
				}
				else if (key === 'scheduleOuterDisk')
				{
					// нужно проверить статус
					if (this.Row['service_status'] !== 'active' || this.Row['service_status_text']) return false
					if (!this.isAccess('backupschedule/create')) return false

					// если уже есть расписание
					if (this.Row['service_data'] && this.Row['service_data']['has_schedule'] === true) return false

					return true
				}
				else if (key === 'scheduleOuterDiskUpdate')
				{
					// нужно проверить статус
					if (this.Row['service_status'] !== 'active' || this.Row['service_status_text']) return false
					if (!this.isAccess('backupschedule/update')) return false

					// если нет расписания
					if (!this.Row['service_data'] || !this.Row['service_data']['has_schedule']) return false

					return true
				}
				else if (key === 'connectISOOper')
				{
					// нужно проверить статус
					if (this.Row['service_status'] !== 'active' || this.Row['service_status_text']) return false
					else {
						if (this.Row['service_data'] && this.Row['service_data']['iso'] && this.Row['service_data']['iso']['attached'] === true) return false
						return true
					}
				}
				else if (key === 'ejectISOOper')
				{
					// нужно проверить статус
					if (this.Row['service_status'] !== 'active' || this.Row['service_status_text']) return false
					else {
						if (this.Row['service_data'] && this.Row['service_data']['iso'] && this.Row['service_data']['iso']['attached'] === true) return true
						return false
					}
				}
				// если это связи обрудования
				else if (key === 'deviceLinks')
				{
					return this.isAccess('rackdevice/links')
				}
				// если это резервирование IP
				else if (key === 'ipReserve')
				{
					if (this.Row['can_reserve'] !== true) return false
					else return true
				}
				else return true
			}

			// по умолчанию - нельзя
			return false
		},
		//---------------------------------------------------------------------
		// куда открывать - вверх или вниз
		//---------------------------------------------------------------------
		UpOrDown() {
			// по умолчанию стиля нет
			this.cssUl = false

			// находим главный блок
			let _div = $('div[data-index="' + this.index + '"]')
			if (!_div.length) return

			// в нем находим блок с меню
			let _ul = _div.find('ul:first')
			if (!_ul.length) return

			// находим расположение главного блока и высоты
			let _rect = _div.offset()
			let _heightDiv = _div.height()
			let _heightUl = _ul.height()

			// расчитаем координаты низ блока с меню
			let _bottomUl = _rect.top + _heightDiv + _heightUl + 10 - $(window).scrollTop()
			// если они ниже высоты окна
			if (_bottomUl > window.innerHeight) this.cssUl = 'top: -' + (_heightDiv + _heightUl) + 'px'
		},
		//---------------------------------------------------------------------
		// инициализация данных
		//---------------------------------------------------------------------
		initButtons() {
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// копируем свойства
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			this.data = Object.assign({}, this.dataConfig)

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// проверяем - допустима ли операция DELETE
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			if ('delete' in this.data)
			{
				let _canDel = false
				// определим если есть точное указание в записи
				if ('can_delete' in this.Row)
				{
					// есть поле "can_delete", смотрим на его значение
					_canDel = Helper.normalizeBooleanValue(this.Row['can_delete'])
				}
				else
				{
					// прямого указания нет - считаем что запись можно удалять
					_canDel = true
					// финансовые операции по умолчанию удалять нельзя - только по прямому указанию
					if (this.crud === 'operation') _canDel = false
					// такого специального поля нет - ищем в других полях статус записи
					for (let nm in this.Row) if (this.Row.hasOwnProperty(nm))
					{
						if (nm.indexOf('_status') >= 0 && String(this.Row[nm]).indexOf('delete') >= 0)
						{
							// нашли такое поле - значит запись со статусом "удалена"
							_canDel = false
							break
						}
					}
				}

				// если это VDS и задан статус операции - удалять нельзя,
				// так делается какая то операция
				if (this.crud === 'vds' && this.Row['service_status_text']) _canDel = false

				// проверка прав доступа
				if (!this.isAccess(this.crud + '/delete')) _canDel = false

				// если это тикет - нельзя закрывать
				if (this.crud === 'ticket') _canDel = false

				// итого, если удалять нельзя - уберем из данных
				if (_canDel === false) this.$delete(this.data, 'delete')
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// проверяем - допустима ли операция UPDATE
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			if ('update' in this.data)
			{
				let _canUpd = false
				if (this.crud === 'operation' && this.$store.state.user_type !== 'admin') _canUpd = false
				else if (this.crud === 'user' && this.$store.state.user_type !== 'admin')
				{
					if (this.Row['user_id'] === this.$store.state.user_id) _canUpd = true
					else
					{
						if ('can_update' in this.Row && !this.Row['can_update'])
						{
							_canUpd = false
						}
						else
						{
							_canUpd = true
							// проверка прав доступа
							if (!this.isAccess(this.crud + '/update')) _canUpd = false
						}
					}
				}
				else
				{
					if (('can_update' in this.Row && !this.Row['can_update']) ||
						this.crud === 'vds' || this.crud === 'additional-services' ||
						(this.crud === 'request' && this.$store.state.user_type !== 'admin'))
					{
						_canUpd = false
					}
					else
					{
						_canUpd = true
						// проверка прав доступа
						if (!this.isAccess(this.crud + '/update')) _canUpd = false
					}
				}

				// итого, если редактировать нельзя - уберем из данных
				if (_canUpd === false) this.$delete(this.data, 'update')
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// проверяем - допустима ли операция CREATE
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			if ('create' in this.data)
			{
				let _canCrt = true

				// проверка прав доступа
				let _crud = this.crud
				if (this.crud === 'servicetype') _crud = 'plan'
				if (!this.isAccess(_crud + '/create')) _canCrt = false

				if (_canCrt && this.crud === 'servicetype')
					if (!('can_create_plan' in this.Row) || this.Row['can_create_plan'] !== true) _canCrt = false

				// итого, если создавать нельзя - уберем из данных
				if (_canCrt === false) this.$delete(this.data, 'create')
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// проверяем - допустима ли операция CLONE
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			if ('clone' in this.data)
			{
				/*
				let _canClone = true

				// проверка прав доступа
				let _crud = this.crud
				if (!this.isAccess(_crud + '/clone')) _canClone = false

				// итого, если нельзя - уберем из данных
				if (_canClone === false) this.$delete(this.data, 'clone')
				*/
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// проверяем - допустима ли операция CLONE
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			if ('vdsClone' in this.data)
			{
				let _canClone = false

				if (this.$store.state.user_type === 'admin') {
					_canClone = true
				} else {
					if ('accountOnly' in this.data.vdsClone) {
						_canClone = this.data.vdsClone.accountOnly === this.$store.state.user_account
					} else {
						_canClone = true
					}
				}

				if (_canClone === false) this.$delete(this.data, 'vdsClone')
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		},
		//---------------------------------------------------------------------
		// изменилась строка
		//---------------------------------------------------------------------
		updateRowHandler(data) {
			// проверка входящих данных
			if (!data || !data['column_id'] || !data['row']) return
			// если это не наша строка
			if (this.Row[data['column_id']] !== data['row'][data['column_id']]) return
			// переинициализация
			this.Row = data['row']
			this.initButtons()
		}

		//---------------------------------------------------------------------
	},
	//=========================================================================
	// наблюдатель
	//=========================================================================
	watch: {
		'row': function(row) {
			this.Row = row
			this.initButtons()
		}
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style>
.w5-opers-button {
	color: #2880da;
	padding: 0 4px;
	border: 1px solid transparent;
	border-radius: 3px;
	transition: all 0.2s;
	cursor: pointer;
	user-select: none;
}

.w5-application.mc .w5-opers-button {
	color: #3250ba;
}

.w5-opers-button-opened {
	color: #333;
	border-color: #adadad;
	background-color: #e6e6e6;
}


.w5-opers-button .dropdown-menu {
	display: block;
	left: auto;
	right: 0;
}

.w5-opers-button .dropdown-menu > li > div.w5-dropdown-menu-item {
	font-size: 14px;
	font-weight: 300;
	color: #333;
	display: block;
	padding: 3px 20px 3px 40px;
	height: 26px;
	line-height: 22px;
	width: 100%;
	text-align: left;
	white-space: nowrap;
	transition: all .2s;
}

.w5-opers-button .dropdown-menu > li > div.w5-dropdown-menu-item > svg {
	margin: auto auto auto 10px;
	width: 20px;
}

.w5-opers-button .dropdown-menu > li > div.w5-dropdown-menu-item:hover {
	color: #262626;
	background-color: #f5f5f5;
}

.w5-opers-button-curd-opers-panel {
	display: flex;
	display: -webkit-box;
    display: -webkit-flex;

	justify-content: space-around;
	-webkit-justify-content: space-around;

	padding: 0 20px;
	color: #333;
	cursor: default;
}

.w5-opers-button-curd-btn {
	display: flex;
	display: -webkit-box;
    display: -webkit-flex;

	justify-content: center;
	-webkit-justify-content: center;

	align-items: center;
	-webkit-align-items: center;

	width: 28px;
	height: 28px;
	cursor: pointer;
	border: 1px solid transparent;
	border-radius: 14px;
	transition: all .2s;
}

.w5-opers-button-curd-btn:hover {
	background-color: #f5f5f5;
}

.w5-opers-button-other-btn {
	font-size: 14px;
	font-weight: 300;
	color: #333;
	display: inline-block;
	height: 26px;
	padding: 3px 20px 3px 0;
	width: 100%;
	line-height: 22px;
	white-space: nowrap;
	transition: all .2s;
}

.w5-opers-button-other-btn:hover {
	color: #262626;
	background-color: #f5f5f5;
}

.w5-opers-button-other-btn .svg-inline--fa {
	font-size: 14px;
	color: #2880da;
	margin: 0 7px 0 10px;
	width: 20px;
	position: relative;
}
.w5-application.mc .w5-opers-button-other-btn .svg-inline--fa {
	color: #3250ba;
}

.w5-oper-menu-icon-plus {
	left: 7px !important;
	top: 5px !important;
	color: #33cc66 !important;
	font-size: 10px !important;
	margin: 0 !important;
}

.w5-oper-menu-icon-note {
	color: #2c8ad8 !important;
	font-size: 12px !important;
	left: 15px !important;
	top: 9px !important;
	margin: 0 !important;
	transform: rotate(45deg);
}
.w5-application.mc .w5-oper-menu-icon-note {
	color: #01196f !important;
}

.w5-oper-menu-icon-vds-clone-server {
	left: 8px !important;
	top: 12px !important;
	color: #2c8ad8 !important;
	font-size: 12px !important;
	margin: 0 !important;
}
.w5-application.mc .w5-oper-menu-icon-vds-clone-server {
	color: #3250ba !important;
}
.w5-oper-menu-icon-vds-clone-clone {
	color: #33cc66 !important;
	font-size: 10px !important;
	left: 20px !important;
	top: 6px !important;
	margin: 0 !important;
	transform: rotate(45deg);
}

.w5-oper-menu-icon-hdd {
	top: 7px !important;
}

.w5-oper-menu-icon-share {
	color: #33cc66 !important;
	font-size: 11px !important;
	left: 14px !important;
	top: 2px !important;
	margin: 0 !important;
}

.w5-opers-button-for-mobile {
	display: flex;
	display: -webkit-box;
	display: -webkit-flex;

	-webkit-flex-wrap: wrap;
  	flex-wrap: wrap;
}

.w5-oper-menu-icon-restoreBackup-arrow {
	color: red !important;
	margin: 0 !important;
    top: -4px !important;
}

.w5-oper-menu-icon-restoreBackup-hdd1 {
	margin: 0 !important;
}

@media screen and (max-width: 767px) {
	.w5-opers-button-curd-btn {
		margin: 5px 10px;
    	color: #2880da;
	}
	.w5-application.mc .w5-opers-button-curd-btn {
    	color: #3250ba;
	}
	.w5-dropdown-menu-item.w5-opers-button-other-btn.fa-layers {
		width: 20px;
		height: 20px;
	}
	.w5-oper-menu-icon-plus {
		left: -5px !important;
    	top: 2px !important;
	}
	.w5-oper-menu-icon-note {
		left: 3px !important;
	}
	.w5-oper-menu-icon-share {
		left: 4px !important;
    	top: -1px !important;
	}
	.w5-column-opers {
    	width: auto !important;
	}
}

</style>



// WEBPACK FOOTER //
// btndropdown.vue?4a0419f4